import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { BODY_TYPES } from 'Style/typography';

import WebLink from 'Webapp/shared/app/components/web-link';

const Link = styled(WebLink)(
  {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  BODY_TYPES.LARGE_STANDARD,
);

const SitemapItem = ({ item }) => <Link href={item.url}>{item.title}</Link>;

SitemapItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default SitemapItem;
